import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { LeafIcon } from 'lucide-react';
interface MenuCardProps {
  name: string;
  price: string;
  ingredients: string[];
  isVegetarian?: boolean;
  delay?: number;
}
export function MenuCard({
  name,
  price,
  ingredients,
  isVegetarian,
  delay = 0
}: MenuCardProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const formattedPrice = price.startsWith('+') ? '+$' + price.slice(1) : '$' + price;
  return <motion.div ref={ref} className="bg-bp-bg2 border border-bp-line2 rounded-bp p-4 transition-all duration-300 hover:-translate-y-1 hover:border-bp-accent flex flex-col h-full" initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 20
  }} transition={{
    duration: 0.6,
    delay
  }} data-id="element-93">
      <div className="flex flex-col mb-3" data-id="element-94">
        <h3 className="font-display text-2xl md:text-3xl text-bp-text tracking-wider uppercase flex items-center gap-2 mb-0.5" data-id="element-95">
          {name}
          {isVegetarian && <LeafIcon className="w-5 h-5 text-bp-accent" strokeWidth={1.25} fill="none" aria-label="Vegetariano" data-id="element-96" />}
        </h3>
        <span className="font-display text-3xl md:text-4xl text-bp-accent tracking-wider" data-id="element-97">
          {formattedPrice}
        </span>
      </div>

      <div className="space-y-0.5 mt-auto" data-id="element-98">
        {ingredients.map((ingredient, index) => <p key={index} className="font-body font-light text-bp-text2 text-sm leading-snug" data-id="element-99">
            {ingredient}
          </p>)}
      </div>
    </motion.div>;
}